import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const FilterIcon = ({
  color = 'foraBlue',
  width = 30,
  marginLeft,
  marginRight,
  containerSize,
  title = 'Fora',
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group 68">
        <path
          id="Vector 40 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 1.5C0.75 1.08579 1.08579 0.75 1.5 0.75H13C13.4142 0.75 13.75 1.08579 13.75 1.5C13.75 1.91421 13.4142 2.25 13 2.25H1.5C1.08579 2.25 0.75 1.91421 0.75 1.5Z"
          fill={getSemanticTextColor(color)}
        />
        <path
          id="Vector 41 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.75 10C4.75 9.58579 5.08579 9.25 5.5 9.25H9C9.41421 9.25 9.75 9.58579 9.75 10C9.75 10.4142 9.41421 10.75 9 10.75H5.5C5.08579 10.75 4.75 10.4142 4.75 10Z"
          fill={getSemanticTextColor(color)}
        />
        <path
          id="Vector 42 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 6C2.75 5.58579 3.08579 5.25 3.5 5.25H11C11.4142 5.25 11.75 5.58579 11.75 6C11.75 6.41421 11.4142 6.75 11 6.75H3.5C3.08579 6.75 2.75 6.41421 2.75 6Z"
          fill={getSemanticTextColor(color)}
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
